import React from 'react'
import Virajimag from '../../Images/viraj_2.jpeg';
function Imagin() {
  return (
    <div className='image1'>
          <img src={Virajimag} className='avatar-logo' />
        
    </div>
  )
}

export default Imagin
